'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearTransactions = undefined;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _reactRouterRedux = require('react-router-redux');

var _fp = require('lodash/fp');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map(); // Lib


var getLastAction = function getLastAction(actionList) {
    return actionList.get(actionList.size - 1);
};

var lastActionIsLocationChange = function lastActionIsLocationChange(actionList) {
    if (!actionList) return false;
    var lastActionType = (0, _fp.get)(['undo', 'type'], getLastAction(actionList));
    return lastActionType === _reactRouterRedux.LOCATION_CHANGE;
};

var clearTransactions = exports.clearTransactions = function clearTransactions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var transactionIds = arguments[1];
    return state.filter(function (actions, transactionId) {
        return transactionIds.indexOf(transactionId) === -1;
    });
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action.transactionId || !action.undoRedoAction) return state;

    if (state.has(action.transactionId)) {
        return state.update(action.transactionId, function (actionList) {
            var undoRedoAction = action.undoRedoAction;
            var updatedActionList = actionList;

            // Collapse location change actions to prevent unnecessary multiple location changes on undo
            if (action.type === _reactRouterRedux.LOCATION_CHANGE && lastActionIsLocationChange(actionList)) {
                var lastAction = getLastAction(actionList);
                undoRedoAction.undo = lastAction.undo;
                updatedActionList = updatedActionList.pop();
            }

            return updatedActionList.push(undoRedoAction);
        });
    }

    return state.set(action.transactionId, Immutable.List([action.undoRedoAction]));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoTransactionsReducer.js
// module id = 2149
// module chunks = 0